module.exports = __webpack_public_path__ + "media/packs/fonts/IsidoraSans-Bold-01aba72f9fc75779de017d9995a76233.woff";